module.exports = __webpack_public_path__ + "img/美妆日化行业结构示意图.8ded1f67.jpg";